import { ActionPlanColumnsIdEnum } from "pages/Corporate/RCA/RCADashboard/components/MyActionPlans/useMyActionPlansColumns/usMyActionPlansColumnsInterfaces";
import { IActionPlanTableOperationFilters } from "./ActionPlanEntityInterfaces";

/** Order value for Hasura order_by (asc | desc) */
export type OrderDirection = "asc" | "desc";

/** Shape of the order_by variable for getAllActionPlans queries */
export interface ActionPlanOrderByVariable {
    sequence_id?: OrderDirection;
    name?: OrderDirection;
    due_date?: OrderDirection;
    status?: { order: OrderDirection };
    assignee?: { first_name: OrderDirection };
    issue?: { sequence_id: OrderDirection };
    rca?: { sequence_id: OrderDirection };
}

/**
 * Builds the order_by object for action plan list queries from table operation filters.
 * Used by GetAllActionPlans, GetAllUserActionPlans, and GetAllActionPlansForApproval.
 */
export function getActionPlanOrderBy(
    tableOperationFilters: IActionPlanTableOperationFilters,
): ActionPlanOrderByVariable {
    const order = tableOperationFilters.order as OrderDirection;
    return {
        ...(tableOperationFilters.orderBy === ActionPlanColumnsIdEnum.NUMBER && {
            sequence_id: order,
        }),
        ...(tableOperationFilters.orderBy === ActionPlanColumnsIdEnum.TYPE && {
            issue: { sequence_id: order },
            rca: { sequence_id: order },
        }),
        ...(tableOperationFilters.orderBy === ActionPlanColumnsIdEnum.NAME && {
            name: order,
        }),
        ...(tableOperationFilters.orderBy === ActionPlanColumnsIdEnum.DUE_DATE && {
            due_date: order,
        }),
        ...(tableOperationFilters.orderBy === ActionPlanColumnsIdEnum.STATUS && {
            status: { order },
        }),
        ...(tableOperationFilters.orderBy === ActionPlanColumnsIdEnum.ASSIGNEE && {
            assignee: { first_name: order },
        }),
    };
}
